import { render } from "./Song.vue?vue&type=template&id=46c37c23&scoped=true"
import script from "./Song.vue?vue&type=script&lang=js"
export * from "./Song.vue?vue&type=script&lang=js"

import "./Song.vue?vue&type=style&index=0&id=46c37c23&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46c37c23"

export default script